export default __webpack_public_path__ + "static/media/portfolio3.d76e7542.png";